/* eslint-disable */
import React from 'react';

const BusinessIntelligenceIcon = props => (
  <svg
    width="42"
    height="42"
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M0 0h42v42H0z" />
    <path fill="#64797D" d="M3 31.89V7.2c0-.12.1-.21.2-.21h35.16c.11 0 .2.1.2.2V31.9a.2.2 0 0 1-.2.2H24.23a.2.2 0 0 0-.2.2v2.03c0 .08.03.14.1.18l1.82 1.12c.18.1.1.38-.1.38H15.42c-.22 0-.29-.29-.1-.39l2.1-1.11a.2.2 0 0 0 .11-.18V32.3a.2.2 0 0 0-.2-.2H3.2a.2.2 0 0 1-.21-.21Z" />
    <path fill="#fff" d="M4.37 8.64H37.2v20.79H4.37z" />
    <path stroke="#4C9BBF" strokeLinecap="round" strokeWidth="1.21" d="M18.65 19.45v1.86m1.81-3.42v3.42m1.82-5.24v5.23" />
    <path fill="#D9D9D9" d="M17.02 11.14c-.07-.14 0-.3.13-.37.92-.4 1.89-.65 2.88-.73.16-.01.29.1.3.26l.16 3.05a.3.3 0 0 1-.27.3c-.52.05-1.03.18-1.51.38a.3.3 0 0 1-.38-.13l-1.31-2.76Z" />
    <path fill="#B7B7B7" d="M12.13 17.71a.27.27 0 0 1-.23-.31 9.03 9.03 0 0 1 4.24-6.1c.13-.08.3-.03.37.1l1.5 2.67a.3.3 0 0 1-.11.38 5.42 5.42 0 0 0-2.42 3.5.29.29 0 0 1-.33.23l-3.02-.47Z" />
    <path fill="#FF9D9D" d="M16.98 26.92a.27.27 0 0 1-.37.12 9.03 9.03 0 0 1-4.84-8.56.27.27 0 0 1 .3-.26l3.04.29c.16.01.27.15.26.3a5.42 5.42 0 0 0 2.8 4.98c.14.07.2.24.13.38l-1.32 2.75Z" />
    <path fill="#FF7373" d="M20.78 10.29c0-.16.13-.28.28-.28a9.03 9.03 0 1 1-3.33 17.52.27.27 0 0 1-.16-.35l1.12-2.84a.29.29 0 0 1 .37-.17 5.42 5.42 0 1 0 2-10.54.29.29 0 0 1-.28-.29V10.3Z" />
  </svg>
);

export default BusinessIntelligenceIcon;
/* eslint-enable */
